import Loadable from 'react-loadable';

import LoadingPage from './components/LoadingPage';

export const AsyncAuth = Loadable({
  loader: () => import('./containers/Auth'),
  loading: LoadingPage,
});

export const AsyncHome = Loadable({
  loader: () => import('./containers/Home'),
  loading: LoadingPage,
});

export const AsyncLogin = Loadable({
  loader: () => import('./containers/Login'),
  loading: LoadingPage,
});

export const AsyncPleaseLogin = Loadable({
  loader: () => import('./containers/PleaseLogin'),
  loading: LoadingPage,
});

export const AsyncAgreements = Loadable({
  loader: () => import('./containers/Agreements'),
  loading: LoadingPage,
});

export const AsyncCheckStatus = Loadable({
  loader: () => import('./containers/CheckStatus'),
  loading: LoadingPage,
});

export const AsyncRegister = Loadable({
  loader: () => import('./containers/Register'),
  loading: LoadingPage,
});

export const AsyncStart = Loadable({
  loader: () => import('./containers/Start'),
  loading: LoadingPage,
});

export const AsyncRefresh = Loadable({
  loader: () => import('./containers/DSRRefreshRequired'),
  loading: LoadingPage,
});

export const AsyncNotFound = Loadable({
  loader: () => import('./containers/NotFound'),
  loading: LoadingPage,
});

export const AsyncRunCheck = Loadable({
  loader: () => import('./containers/RunCheck'),
  loading: LoadingPage,
});

export const AsyncWelcome = Loadable({
  loader: () => import('./containers/Welcome'),
  loading: LoadingPage,
});

export const AsyncFAQ = Loadable({
  loader: () => import('./containers/FAQ'),
  loading: LoadingPage,
});

export const AsyncConsent = Loadable({
  loader: () => import('./containers/Consent'),
  loading: LoadingPage,
});



// WEBPACK FOOTER //
// ./src/RouteLoaders.js